"use strict";
(() => {
    var M = "ADD_TO_CART_ERROR",
        A = "ADD_TO_CART";
    var I = {
            pillowP1: "24x75",
            pillowP2: "48x75",
            pillowP3: "50x50",
            pillowP4: "70x70",
            pillowP5: "100x100",
            pillowP6: "35x35",
            pillowP7: "72x48",
            pillowP8: "96x48",
        },
        b = (r) => r.charAt(0).toUpperCase() + r.slice(1),
        k = {
            en: "Cushion Details",
            de: "Kissen Details",
            fr: "D\xE9tails coussins",
            it: "Dettagli cuscini",
            nl: "Kussen details",
        };
    var T = ({ groupId: r, items: a, lang: l }) => {
        let p = [...a].sort(
                (n, e) => (n.bundlePosition ?? Number.MAX_SAFE_INTEGER) - (e.bundlePosition ?? Number.MAX_SAFE_INTEGER)
            ),
            c = { _set_id: r },
            u = new Map();
        for (let n of p) {
            let e = b(n.color ?? "unknown"),
                o = b(n.fabric ?? "unknown"),
                t = I[n.elementType ?? ""] ?? n.elementType ?? "unknown",
                i = `${e}-${o}`;
            u.has(i) || u.set(i, new Map());
            let d = u.get(i);
            d.set(t, (d.get(t) ?? 0) + 1);
        }
        let m = [];
        for (let [n, e] of Array.from(u.entries())) {
            let o = Array.from(e.entries())
                .map(([t, i]) => `${i}x ${t}cm`)
                .join(" / ");
            m.push(`${n} / ${o}`);
        }
        let s = m.join(" | ");
        if (s) {
            let n = k[l ?? "en"] ?? k.en;
            c[n] = s;
        }
        c._cushion_data = JSON.stringify(
            p.map((n) => ({
                size: I[n.elementType ?? ""] ?? n.elementType ?? "unknown",
                color: n.color ?? "unknown",
                fabric: n.fabric ?? "unknown",
            }))
        );
        let g = p.find((n) => n.color)?.color ?? "";
        return g && (c._color = g), c;
    };
    var _ = (r) => r.split("/").pop(),
        f = {
            default: {
                Harvey: "43192163008665",
                Donna: "42941836198041",
                Donna2: "56257775272318",
                Katrina: "42941837344921",
                Katrina2: "56220850782590",
                MikeL: "42941825679513",
                MikeR: "42941825679513",
                MikeL2: "56262952386942",
                MikeR2: "56262952386942",
                Mike: "56262952386942",
                Nina: "43454665261209",
                Louis: "43466405380249",
                Amelie: "42941835378841",
                Jessica: "42941837115545",
                Paula: "43475298451609",
                Marie: "42941839016089",
                Amy: "56258480865662",
                Aera: "56474279051646",
                Terra: "56987195605374",
            },
            ch: {
                Harvey: "43192163008665",
                Donna: "42941836198041",
                Donna2: "56257775272318",
                Katrina: "42941837344921",
                Katrina2: "56220850782590",
                MikeL: "42941825679513",
                MikeR: "42941825679513",
                MikeL2: "56262952386942",
                MikeR2: "56262952386942",
                Mike: "56262952386942",
                Nina: "43454665261209",
                Louis: "43466405380249",
                Amelie: "42941835378841",
                Jessica: "42941837115545",
                Paula: "43475298451609",
                Marie: "42941839016089",
                Amy: "56258480865662",
                Aera: "56474279051646",
                Terra: "56987195605374",
            },
            eu: {
                Harvey: "42753242661054",
                Donna: "42481184768190",
                Donna2: "55752728150396",
                Katrina: "42481195745470",
                Katrina2: "55720086176124",
                MikeL: "42481218879678",
                MikeR: "42481218879678",
                MikeL2: "55759630991740",
                MikeR2: "55759630991740",
                Mike: "55759630991740",
                Nina: "43092670546110",
                Louis: "43326118854846",
                Amelie: "42481180410046",
                Jessica: "42481180410046",
                Paula: "43099401322686",
                Marie: "42481212653758",
                Amy: "55756018712956",
                Aera: "55893192376700",
                Terra: "56527504834940",
            },
            it: {
                Harvey: "44647556808892",
                Donna: "44647504871612",
                Donna2: "45210168459452",
                Katrina: "44647505133756",
                Katrina2: "45179500298428",
                MikeL: "44647505199292",
                MikeR: "44647505199292",
                MikeL2: "45213508632764",
                MikeR2: "45213508632764",
                Mike: "45213508632764",
                Nina: "44647579975868",
                Louis: "44647599112380",
                Amelie: "44647504904380",
                Jessica: "44647504969916",
                Paula: "44647580041404",
                Marie: "44647505100988",
                Amy: "45210681475260",
                Aera: "45356768723132",
                Terra: "45976858460348",
            },
            at: {
                Harvey: "55268618174843",
                Donna: "55268556407163",
                Donna2: "55746211119483",
                Katrina: "55268556800379",
                Katrina2: "55730125177211",
                MikeL: "55268557226363",
                MikeR: "55268557226363",
                MikeL2: "55748334387579",
                MikeR2: "55748334387579",
                Mike: "55748334387579",
                Nina: "55268651499899",
                Louis: "55268675387771",
                Amelie: "55268556439931",
                Jessica: "55268556669307",
                Paula: "55268655595899",
                Marie: "55268556964219",
                Amy: "55746617213307",
                Aera: "55870007083387",
                Terra: "56106873913723",
            },
            fr: {
                Harvey: "52232076263793",
                Donna: "52232031109489",
                Donna2: "62366281728369",
                Katrina: "52232031207793",
                Katrina2: "55789231210865",
                MikeL: "52232031371633",
                MikeR: "52232031371633",
                MikeL2: "62368756302193",
                MikeR2: "62368756302193",
                Nina: "52232097825137",
                Louis: "52232118763889",
                Amelie: "52232030945649",
                Jessica: "52232031175025",
                Paula: "52232103231857",
                Marie: "52232031273329",
                Amy: "62366559666545",
                Aera: "62550367928689",
                Terra: "63239555973489",
            },
            nl: {
                Harvey: "44712062976053",
                Donna: "44712065859637",
                Donna2: "44712065859637",
                Aera: "44763827404853",
                Terra: "45015198924853",
            },
        },
        w = (r) => (r in f ? r : "default"),
        P = (r, a) => {
            let l = crypto.randomUUID(),
                p = ["en", "de", "fr", "it", "nl"],
                c = window.location.pathname.split("/")[1] ?? "",
                u = p.includes(c) ? c : "de";
            if (r.preview && l)
                try {
                    localStorage.setItem(l, r.preview);
                } catch (e) {
                    console.warn("Failed to store preview in localStorage:", e);
                }
            let m = r.items.reduce((e, o) => {
                    if (o.bundleId && o.bundlePosition) {
                        let t = e[o.bundleId] || { bundleId: o.bundleId, items: [] };
                        t.items.push(o), (e[o.bundleId] = t);
                    }
                    return e;
                }, {}),
                s = [];
            Object.entries(m).forEach(([e, o]) => {
                let { bundleId: t, items: i } = o,
                    d = T({ groupId: l, items: i, lang: u }),
                    y = _(t);
                if (!y) {
                    console.error("\u274C [ATC] Could not extract variant ID from bundleId:", t);
                    return;
                }
                s.push({ quantity: 1, id: y, properties: d });
            }),
                r.items.forEach((e) => {
                    if (e.bundleId && e.bundlePosition) {
                        console.log("Skipping bundle item:", e.shopifyId, "bundleId:", e.bundleId);
                        return;
                    }
                    let o = { _set_id: l };
                    e.omitColor || (o.Color = e.color || r.color);
                    let t = _(e.shopifyId);
                    t &&
                        (console.log("Adding individual item:", t),
                        s.push({ quantity: e.quantity, id: t, properties: o }));
                });
            let g = w(r.store),
                n = f[g]?.[r.model] || f.default[r.model];
            n &&
                s.push({
                    quantity: 1,
                    id: n,
                    properties: { _link: r.compositionUrl || "", _set_id: l, _title: r.model, _price: "0", _set: l },
                }),
                console.log(
                    "\u{1F6D2} [ATC] Attempting to add items:",
                    s.map((e) => ({ id: e.id, quantity: e.quantity, properties: e.properties }))
                ),
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ items: s }),
                })
                    .then(async (e) => {
                        if (!e.ok) {
                            let o = await e.json().catch(() => ({})),
                                t = o?.description || e.statusText || "Unknown error";
                            throw (
                                (console.error("\u274C [ATC] Cart add failed:", t),
                                console.error("\u274C [ATC] Error details:", o),
                                s.forEach((i, d) => console.error(`  ${d + 1}. Variant ID: ${i.id}`, i.properties)),
                                a.postMessage(
                                    {
                                        type: M,
                                        payload: {
                                            error: t,
                                            failedItems: s.map(({ id: i, quantity: d }) => ({ id: i, quantity: d })),
                                        },
                                    },
                                    "*"
                                ),
                                new Error(t))
                            );
                        }
                        return e.json();
                    })
                    .then(() => {
                        let e = window.location.pathname.split("/")[1] ?? "",
                            t = ["en", "de", "fr", "it"].includes(e) ? `/${e}` : "";
                        window.location.href = `${t}/cart`;
                    })
                    .catch(console.error);
        },
        R = (r) => {
            if (r?.data?.type)
                try {
                    let a = r.data;
                    a.type === A && P(a.payload, r.source);
                } catch (a) {
                    console.error(a);
                }
        };
    window.addEventListener("message", R, !1);
})();
